import React, { useState } from 'react';
import { Box, Switch, CircularProgress } from '../../../ui/core';
import useStationMutations from '../../../hooks/useStationMutations';

const StationOperationalField = ({ station }) => {
  const { operational } = station;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { updateStation } = useStationMutations();

  const onChange = async (e) => {
    setIsSubmitting(true);
    await updateStation(station.id, { operational: e.target.checked });
    setIsSubmitting(false);
  };

  return (
    <Box display="flex" alignItems="center" height="32px" width="52px">
      <Switch sx={{ transform: 'scale(2)' }} checked={!!operational} onChange={onChange} />
      {isSubmitting && <CircularProgress size={16} sx={{ ml: '24px' }} />}
    </Box>
  );
};

export default StationOperationalField;
